export default {
  publicities: {
    loading: false,
    success: false,
    message: '',
    error: null,
    data: [],
  },
  addPublicity: {
    loading: false,
    success: false,
    message: '',
    error: null,
  },
  executePublicity: {
    loading: false,
    success: false,
    message: '',
    error: null,
  },
  calcPublicityCost: {
    loading: false,
    success: false,
    message: '',
    error: null,
  },
  deleteCampaign: {
    data: null,
    loading: false,
    error: null,
  },
};
